export default __webpack_public_path__ + "static/media/omitir-permiso-camara-windows.7129e56f.svg";